// @flow

import type { FormError } from '../store/reducers/auth';

type Input = {
  email: string,
  password: string
}

type Output = FormError[];

const validate = (hash: Input): Output => {
  const rules = {
    email: (input: string): ?string => {
      if (input.length < 1) {
        return 'email_presence';
      }
      return null;
    },
    password: (input: string): ?string => {
      if (input.length < 1) {
        return 'password_presence';
      }
      return null;
    }
  };
  return Object.keys(hash).reduce((memo, key) => {
    const error = rules[key](hash[key]);
    if (error) {
      return memo.concat({
        field: key,
        code: error
      });
    }
    return memo;
  }, []);
};


export default validate;


// WEBPACK FOOTER //
// ./src/validators/login.js